/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Authorization/Enum/Role.php */
export const role = {
	member: 'member',
	admin: 'admin',
	jobillan: 'jobillan',
	recruiter: 'recruiter',
} as const

/** @see backend/nexus/modules/Authorization/Enum/Role.php */
export type Role = (typeof role)[keyof typeof role]
